// extracted by mini-css-extract-plugin
export default {"closeXHoverParent":"layouts_closeXHoverParent__u8UmC","closeXButton":"layouts_closeXButton__EvKgr"};